<template>
  <div class="black-friday-page">
    <BlackFridayBanner />

    <BlackFridayCards
      @openModal="openModal"
    />

    <SchoolNewForm />

    <SchoolNewBreadcrumbs :breadcrumbs="breadcrumbs" />

    <transition name="fade">
      <BlackFridayModal
        v-if="showModal"
        :modal-title="modalTitle"
        @closeModal="closeModal"
      />
    </transition>
  </div>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import BlackFridayBanner from '../../components/v2/black-friday-24/BlackFridayBanner.vue';
import BlackFridayCards from '../../components/v2/black-friday-24/BlackFridayCards.vue';
import SchoolNewForm from '../../components/v2/school-new/SchoolNewForm.vue';
import BlackFridayModal from '../../components/v2/black-friday-24/BlackFridayModal.vue';
import SchoolNewBreadcrumbs from '../../components/v2/school-new/SchoolNewBreadcrumbs.vue';

// eslint-disable-next-line
const TILDA_PAGE = 'https://schooluniversity.ru/skidki?utm_source=SiteSynergy&utm_medium=site&utm_campaign=202508043&utm_term=%D1%80%D0%B0%D0%B7%D0%B4%D0%B5%D0%BB_%D1%81%D0%BA%D0%B8%D0%B4%D0%BA%D0%B8_%D0%B0%D0%BA%D1%86%D0%B8%D0%B8&marketer=dvk&produkt=67018269&utm_gen=3';

export default {
  name: 'BlackFriday24Page',
  components: {
    BlackFridayBanner,
    BlackFridayCards,
    SchoolNewForm,
    BlackFridayModal,
    SchoolNewBreadcrumbs,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  middleware({ redirect }) {
    redirect(301, TILDA_PAGE);
  },

  data: () => ({
    // для head
    title: 'Стоимость обучения в онлайн-школе «Синергия» на 2024-2025 учебный год',
    // eslint-disable-next-line max-len,vue/max-len
    description: 'Описание тарифов и цены на обучение в домашней школе  «Синергия»: распродажи, акции и скидки 2024-2025 учебного год на одной странице',
    image: '/v2/black-friday-24/share-image.jpg',
    headScripts: [{
      // eslint-disable-next-line max-len,vue/max-len
      src: 'https://js.onef.pro/static/reg1f_v1.js?1f_pixel_id=24aed672-c5f3-4e78-ba7e-eed74b860cd1&event_type=visit&product=school_synergy_ru',
      defer: true,
      type: 'text/javascript',
    }],
    canonical: true,

    showModal: false,
    modalTitle: null,

    breadcrumbs: [
      { text: 'главная', to: '/' },
      { text: 'черная пятница', to: '/sale' },
    ],
  }),

  methods: {
    openModal(modalTitle) {
      this.modalTitle = modalTitle;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.modalTitle = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.black-friday-page {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 128);
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  font-family: 'Onest', sans-serif;

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 80);
    gap: calc(var(--scale) * 40);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
    gap: calc(var(--scale) * 28);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }

  ::v-deep(.main-title) {
    position: relative;
    font-family: 'Onest', sans-serif;

    p {
      position: absolute;
      left: 0;
      top: 1.25rem;

      font-weight: 500;
      font-size: 1.625rem;
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }

      @include media-down($size-mobile) {
        position: relative;
        top: 0;
        margin-bottom: -0.2rem;
      }

      & + h2 {
        text-indent: calc(var(--scale) * 465);

        @include media-down($size-tablet) {
          text-indent: calc(var(--scale) * 186);
        }

        @include media-down($size-mobile) {
          text-indent: 0;
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: 4rem;
      }

      span {
        color: #A7ABAC;
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>
